<app-ag-grid style="height: 90vh" [gridOptions]="gridOptions"></app-ag-grid>
